import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { routeNames } from "./routes";
import { UrlWithoutParam } from "../utils/common";
import { setPendingDeepLinkUrl } from "../utils/deepLinkHelper";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated() === false) {
    // Preserve the current URL (including deep-link tokens) through the
    // signup/signin flow. Signin.jsx and ReviewProfileInfo.jsx call
    // consumePendingDeepLinkUrl after auth succeeds and navigate back here.
    setPendingDeepLinkUrl();
    return <Navigate to={UrlWithoutParam(routeNames.signup)} replace />;
  }

  return children;
};

export default ProtectedRoute;
